<template>

    <div>
        <!-- Заголовок -->
  
        <q-toolbar color="primary" >
            <q-toolbar-title class='col-3'>
                Наименование материала
                <span slot="subtitle">
                <!-- Subtitle -->
                </span>
            </q-toolbar-title>
            <q-toolbar-title class='col-md-7 col-lg-7 col-xs-8 row'>
                    <q-toolbar-title v-for='quality in qualities' :key=quality.id >
                        {{quality.name}}
                        <span slot="subtitle">
                            качество печати
                        </span>
                    </q-toolbar-title>
            </q-toolbar-title>
             <q-toolbar-title class='col-md-3 col-lg-3 col-lg-2 row align-right justify-center' shrink>
                <q-btn class='gt-sm' v-if="notSaved" flat color="privary" icon="save" label="" @click="savePrice"/>
                <!-- <q-btn class='gt-sm' flat color="privary" icon="print" label=""/> -->
             </q-toolbar-title>
        </q-toolbar>
  
        <!-- Основная часть -->
        <div v-for="(item) in materials" 
            :key="item.id" class="line-container row no-wrap justify-start items-center">
            
            <div class="col-3 no-wrap ellipsis-3-lines q-body-2">
                {{item.name}}
            </div>   
            
            <div class="col-md-7 col-sm-7 col-xs-7 row no-wrap price_field">
                <edit-price v-for='quality in qualities' 
                    :key=quality.id 
                    :directionId=directionId
                    :matId=item.id
                    :qualityId=quality.id
                />
            </div>

        </div>


    </div>

</template>

<script>
/* eslint-disable */

export default {

    name : "price_shirka",

    components : {
        'edit-price' : () => import('./edit_price.vue'),
    },
    
    props:{
            directionId : {
                type: Number,
                requered: true,
            },
    },

    data () {
        return {
  
        }
    },

    computed :{

        notSaved() {
            return this.$store.getters.savedStatus(this.directionId);
        },

        materials() {
            return this.$store.getters.getMaterialsByDirection(this.directionId);
        },

        qualities() {
            return this.$store.getters.getQualityByDirection(this.directionId);
        },
    },
    methods : {

        savePrice() {
            eventBus.$emit('savePrice'); // пусть основной контейнер прайсов и сохраняет прайсы.. а мы только покажем
         },

    },
}
</script>

<style lang="scss" scoped>

    .line-container {
        background : rgb(238, 238, 238);
        min-height: 45px;
        padding : 8px;
        // margin-bottom: 1px;
        border : 1px solid rgb(201, 201, 201);
        cursor: pointer;
        word-wrap: none;
        margin-top: -1px;
        &:hover {
            background: lightgreen;
        }
    }


</style>
